export default __webpack_public_path__ + "static/media/ryanpic.a411ff22.JPG";